<template>
    <ul ref="printable-bookings" class="printable-bookings-container" :style="containerStyle">
        <li v-for="b in bookings" :key="b.id" class="printable-booking">
            <div>
                <b>{{b.display_id}}</b>
            </div>
            <div class="service">
                <div>{{$t('provider.service_datetime')}}: {{ b.display_datetime_duration }}</div>
                <div>{{$t('provider.service')}}: {{ b.service.title }}</div>
                <div>{{$t('provider.member_user')}}: {{ b.member_user.name }}</div>
            </div>
            <div class="customer">
                {{$t('booking.customer_information')}}: {{b.customer.name}}
                +{{b.customer.phone_calling_code}}-{{b.customer.phone_number}} {{b.customer.email}}
            </div>
            <div class="payments">
                <div v-if="paymentsOfStatus(b, 'pending').length > 0"><span
                        class="text-muted">{{$t('payments.pending_summary', {sum: pendingPaymentSum(b), count:
                        paymentsOfStatus(b, 'pending').length})}}</span></div>
                <div v-if="paymentsOfStatus(b, 'paid').length > 0"><span
                        class="text-success">{{$t('payments.paid_summary', {sum: paidPaymentSum(b), count:
                        paymentsOfStatus(b, 'paid').length})}}</span></div>
                <div v-if="paymentsOfStatus(b, 'expired').length > 0"><span
                        class="text-danger">{{$t('payments.expired_summary', {sum: expiredPaymentSum(b), count:
                        paymentsOfStatus(b, 'expired').length})}}</span></div>
                <div v-if="paymentsOfStatus(b, 'cancelled').length > 0"><span
                        class="text-danger">{{$t('payments.cancelled_summary', {sum: cancelledPaymentSum(b), count:
                        paymentsOfStatus(b, 'cancelled').length})}}</span></div>
            </div>
            <div v-if="b.order && b.order.items.length > 0">
                <br>
                <div> {{$t('order')}}:</div>
                <div>
                    <div>
                        <div v-for="item in b.order.items" :key="item.id">
                            <template>
                                <div class="d-inline-block" style="width: 300px;">{{item.title}}
                                    <small v-if="item.orderable_type === 'App\\Models\\Service' || item.orderable_type === 'App\\Models\\ProviderItem' || item.orderable_type === 'App\\Models\\ProviderItemSpec'" class="text-muted d-inline-block">{{item.price | toCurrency}}x{{item.count}}</small>
                                </div>
                                <div class="text-right d-inline-block"><small>{{item.total | toCurrency}}</small></div>
                            </template>
                        </div>
                    </div>
                    <div v-if="b.order.logistic">
                        <div class="d-inline-block" style="width: 300px;">{{$t('logistic_fee')}}</div>
                        <div class="text-right d-inline-block"><small>${{b.order.logistic_total}}</small></div>
                    </div>
                    <div class="d-flex">
                        <div class="d-inline-block" style="width: 300px;">{{$t('total')}}</div>
                        <div class="text-right d-inline-block"><small>${{b.order.total}}</small></div>
                    </div>
                </div>
            </div>
            <div v-if="b && b.order && b.order.logistic">
                <br>
                <div> {{$t('logistic')}}:</div>
                <div>
                    {{b.order.logistic.display_name}}
                    <small class="text-muted d-inline-block">{{$t('logistics.type_' + b.order.logistic.type)}}/
                        {{$t('logistics.rule_' + b.order.logistic.rule_type)}}/
                        {{ $t('logistics.condition_' + b.order.logistic.condition)}}</small>

                    <div v-if="b.order.logistic.address || b.order.logistic.admin_level_1">
                        {{b.order.logistic.postal_code}}
                        {{$t('country.' + b.order.logistic.country)}}
                        {{b.order.logistic.admin_level_1}}
                        {{b.order.logistic.admin_level_2}}
                        {{b.order.logistic.address}}
                    </div>
                    <div v-if="b.order.logistic.type !== 'FREE_OR_SELF_TAKEN'">
                        {{b.order.logistic.receiver_name || b.customer.name}}
                        <span v-if="b.order.logistic.receiver_phone">{{b.order.logistic.receiver_phone}}</span>
                        <span v-else>+{{b.customer.phone_calling_code}}-{{b.customer.phone_number}}</span>
                        {{b.customer.email}}
                    </div>
                </div>
            </div>
            <div v-if="b.note" class="note white-space-pre-line">
                {{b.note}}
            </div>
            <div v-if="nonEmptyAnswersOfBooking(b).length > 0" class="form my-3">
                <div v-for="answer in nonEmptyAnswersOfBooking(b)" :key="answer.id">
                    <div>
                        Q. {{answer.question.parsedContent?.meta.title || ''}}
                    </div>
                    <div class="mb-2">
                        <!-- Simple text answer -->
                        <span v-if="!answer.parsedContent || (typeof answer.parsedContent !== 'object')"
                            class="field-value">{{answer.content}}</span>
                        <!-- Date answer -->
                        <span v-if="answer.parsedContent && answer.parsedContent.date"
                            class="field-value">{{answer.parsedContent.date}}</span>
                        <!-- Linear scale answer -->
                        <span v-if="answer.parsedContent && (answer.parsedContent.scale === 0 || answer.parsedContent.scale)" class="field-value">
                            {{ answer.parsedContent.scale }}
                        </span>
                        <!-- Single/Multiple Choices -->
                        <div v-for="(o, index) in optionsToDisplayForAnswer(answer)" class="option-container" :key="index">
                            <!-- Option Image won't be printed -->
                            <span class="option-text">{{o.text}}</span>
                            <!-- noteMap text -->
                            <div v-if="o.note" class="field-note ml-1 mr-1 pl-1 pr-1 text-left"> {{o.note}} </div>
                        </div>
                        <!-- Single/Multiple Matrix -->
                        <div v-for="(m, index) in answerToDisplayForMatrix(answer)" class="option-container" :key="index">
                            <span class="option-text">{{m.text}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        bookings: {type: Array, rqeuired: true},
        context: {type: Object, rqeuired: true},
        scale: {type: String, default: 's'}
    },
    mounted() {
        window.addEventListener('afterprint', this.afterPrint);
        this.print();
    },
    destroyed() {
        window.removeEventListener('afterprint', this.afterPrint);
    },
    computed: {
        containerStyle() {
            const fontSize = {'s': '14px', 'm': '16px', 'l': '22px'}[this.scale];
            console.log(fontSize);
            return { fontSize };
        }
    },
    methods: {
		paymentsOfStatus(booking, status) {
			return booking.payments.filter((p) => p.status.toLowerCase() === status);
		},
		paidPaymentSum(booking) {
			return this.paymentsOfStatus(booking, 'paid').reduce((accum, p) => accum + parseInt(p.amount), 0);
		},
		expiredPaymentSum(booking) {
			return this.paymentsOfStatus(booking, 'expired').reduce((accum, p) => accum + parseInt(p.amount), 0);
		},
		pendingPaymentSum(booking) {
			return this.paymentsOfStatus(booking, 'pending').reduce((accum, p) => accum + parseInt(p.amount), 0);
		},
		cancelledPaymentSum(booking) {
			return this.paymentsOfStatus(booking, 'cancelled').reduce((accum, p) => accum + parseInt(p.amount), 0);
		},
        print() {
            $('body').addClass('printing');
            $('body').append(this.$refs['printable-bookings']);

            window.print();
        },
        afterPrint() {
            $('body').removeClass('printing');
            let ref = this.$refs['printable-bookings'];
            if (ref && ref.parentElement) {
                ref.parentNode.removeChild(ref);
            }
            this.$emit('close');
        },
        nonEmptyAnswersOfBooking(b) {
            if (!b.answers) {
                return [];
            }

            return b.answers.filter((answer) => {
                if (answer.parsedContent) {
                    if (answer.parsedContent.choices) {
                        return answer.parsedContent.choices.length > 0;
                    }

                    if (answer.parsedContent.files) {
                        return false;
                    }
                }

                if (answer.selected_options && answer.selected_options.length > 0) {
                    return true;
                }
                
                // Lastly check if it's a multiple selection with notes
                // If it is, then it's empty because there's no selected options
                if (answer.parsedContent && answer.parsedContent.noteMap) {
                    return false;
                }

                return !!answer.content
            });
        },
        optionsToDisplayForAnswer(answer) {
            var answersWithoutMatchingOptions = [];
            var choices = [];
            if (answer.parsedContent && answer.parsedContent.choices) {
                choices = answer.parsedContent.choices;
            } else if (answer.selected_options) {
                // LEGACY: Get all selected choices from `selected_options` which is references-based
                choices = answer.selected_options.map((item) => { return item.option.content_unit.text; });
            }

            // loop through choices and see if there's any with no option matched
            var optionsToDisplay = [];
            choices.forEach((choiceText) => {
                var optionFound = answer.question.options.filter((o) => o.content_unit.text === choiceText);
                var note = null;
                var imageUrl = null;
                if (optionFound.length > 0) {
                    var selectedOption = optionFound[0];

                    imageUrl = selectedOption.content_unit.file_name ? this.context.storageEndpoint + selectedOption.content_unit.file_name : null;
                    if (answer.parsedContent && answer.parsedContent.noteMap) {
                        note = answer.parsedContent.noteMap[choiceText] || answer.parsedContent.noteMap[selectedOption.provider_option_id];
                    }
                } else {
                    if (answer.parsedContent && answer.parsedContent.noteMap) {
                        note = answer.parsedContent.noteMap[choiceText];
                    }
                }
                optionsToDisplay.push({ text: choiceText, imageUrl, note });
            });
            return optionsToDisplay;
        },
        answerToDisplayForMatrix(answer) {
            if (!answer.parsedContent?.matrixChoicesMap) {
                return;
            }

            const choicesMap = answer.parsedContent.matrixChoicesMap;
            const rowList = Object.values(choicesMap);

            var answerToDisplay = [];
            rowList.filter(row => row.length).forEach((row) => {
                const text = row.join(', ');
                answerToDisplay.push({ text });
            });
            return answerToDisplay;
        },
    }
}
</script>

<style lang="scss">
    @media print {
        body > *:not(.printable-bookings-container) {
            display: none !important;
        }
    }

    .printable-bookings-container {
        @media screen {
            & {
                display: none;
            }
        }
        overflow: hidden;
        z-index: 100000000000;
        background: white;

        list-style: none;
        padding: 0;
        margin: 0;

        li {
            padding: 16px;
            margin: 0;
            border-bottom: 1px dashed #888;
            break-inside: avoid;

            &::last-child {
                border-bottom: none;
            }

            display: block;
        }
    }
</style>

<i18n>
{
    "zh": {
        "order": "訂單內容",
        "logistic_fee": "物流費用",
        "total": "總計",
        "logistic": "物流配送"
    },
    "en": {
        "order": "Order",
        "logistic_fee": "Delivery Fee",
        "total": "Total",
        "logistic": "Delivery"
    }
}

</i18n>